<div style="display: flex; justify-content: space-between;">
    <mat-card class="mat-elevation-z0">
        <mat-card-title>Summary: {{instance?.Name}} - {{instance?.State}}</mat-card-title>
        <mat-card-content style="display: flex;">
            <div class="zc-stat-block">
                Property Records: {{ instance?.PropertyRecordsCount }}
                <br />
                Calculation results: {{ instance?.CalculationResultsCount }}
            </div>
            <div class="zc-stat-block">
                Zoning Codes: {{ instance?.ZoningCodesCount }}
                <br />
                Zoning Code Versions: {{ instance?.ZoningCodeVersionsCount }}
            </div>
            <div class="zc-stat-block">
                Last Optimized: {{ instance?.lastOptimizedFormatted }}
                <br />
                Updated At: {{ instance?.updatedAtFormatted }}
            </div>
            <div style="padding-top: 2px;">
                <app-update-instance-statistic-button>
                </app-update-instance-statistic-button>
            </div>
        </mat-card-content>
    </mat-card>
    <div style="padding: 50px 20px 0px 0px ;">
        <app-remove-selected-processes *ngIf="jobsTabActive" [processesList]="jobs$|async">
        </app-remove-selected-processes>
        <app-archive-selected-processes *ngIf="jobsTabActive" [processesList]="jobs$|async"
            class="processes-action-button">
        </app-archive-selected-processes>
    </div>
</div>

<mat-tab-group class="mat-elevation-z0" #tabs mat-stretch-tabs="false">
    <mat-tab label="Zoning Codes">
        <app-zoning-codes-view [instance]="instance"></app-zoning-codes-view>
    </mat-tab>

    <mat-tab label="Property Records">
        <app-property-records-tab></app-property-records-tab>
    </mat-tab>

    <mat-tab label="Jobs">
        <app-paginated-jobs-list [jobs$]="jobs$" [totalJobsCount]="totalJobsCount" [getArchived]="false"
            [pageChanged]="pageChanged.bind(this)" [state]="instance?.State" [showSelectedColumn]="true"
            [searchParamsChanged]="searchParamsChanged.bind(this)">
        </app-paginated-jobs-list>
    </mat-tab>

    <mat-tab label="Monitoring">
        <!-- ng-template is used to recreate component each time user visit tab.
      In other case component initializes immediately which may slow application.
      Source https://stackoverflow.com/questions/56634134/angular-material-tabs-load-unload-components-only-when-active-tab-is-selected -->
        <ng-template matTabContent>
            <app-instance-monitoring></app-instance-monitoring>
        </ng-template>
    </mat-tab>
</mat-tab-group>

<app-spinner [showOverlay]="false" *ngIf="showSpinner"></app-spinner>